
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import SchoolLegalEntityContent from './Components/SchoolLegalEntityContent.vue';

export default defineComponent({
    name: "SchoolLegalEntityContentPage",
    components: {
        BreadCrumb,
        SchoolLegalEntityContent
    },
});
